// utils/textFormatter.ts

export const textFormatter = (text: string): string => {
  if (!text?.trim()) return "";

  return text
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
